/**
 * Event / ticketing upsell config (post-booking success).
 * - Empty `shopUrl` → hide sidebar Event + modal event CTA (success modal still shows).
 * - Set `shopUrl` → enable sidebar Event + "Continue to Event" on success modal
 *   (opens the ticketing platform so masqueraders can book tickets).
 */
export const SHOP_CONFIG = {
  // Empty string disables Event CTA + sidebar only (success modal still shows)
  shopUrl: "https://gemsevents.carnivaltribe.com/",
  upsell: {
    title: "Package booked",
    subtitle: "Your costume package has been reserved.",
    secondaryCta: "Stay on Orders",
    dismissCta: "Continue",
  },
} as const;

export const SHOP_UPSELL_SESSION_KEY = "gem.shopUpsellPending";
